import * as $ from 'jquery';
import * as kendo from 'kendo/kendo.core';
import RISIndexRepository from 'visuris/Data/Repositories/RISIndexRepository';
import 'kendo/kendo.data';
import RisIndexLocationSearchResult from '../Entities/RisIndexLocationSearchResult';

export function create(options?: kendo.data.DataSourceOptions, relation?: any, searchRole?: number, searchFavorites?: boolean): kendo.data.DataSource {
    const risRepository = new RISIndexRepository();
    const dataSourceOptions: kendo.data.DataSourceOptions = {
        transport: {
            read: (kendoOptions: kendo.data.DataSourceTransportReadOptions) => {
                if (kendoOptions.data && kendoOptions.data.filter && kendoOptions.data.filter.filters.length > 0) {
                    const filters = kendoOptions.data.filter.filters as kendo.data.DataSourceFilterItem[];
                    const text = filters.find(x => x.field === 'objectName')?.value;
                    const countryCode = filters.find(x => x.field === 'countryCode')?.value;
                    const fairway = filters.find(x => x.field === 'fairway')?.value;
                    const distanceMarks = filters.find(x => x.field === 'distanceMarks')?.value;
                    const hideAll = filters.find(x => x.field === 'hideAll')?.value;
                    const skip = kendoOptions.data.skip;
                    const top = kendoOptions.data.take;
                    const odataQueryParams = `&$top=${top ?? 0}&$skip=${skip ?? 15}`;
                    const filterFunctions = filters.filter(x => x.field === 'function').map(x => x.value);
                    const filterFunctionsStr = filterFunctions.length > 0 ? filterFunctions.join(';') : null;
                    if (hideAll) {
                        kendoOptions.success(new RisIndexLocationSearchResult());
                    } else {
                        if (text != null && text !== '') {
                            const locationSearchResult = risRepository.suggest(text, searchRole, countryCode, fairway, distanceMarks, filterFunctionsStr, odataQueryParams);
                            if (searchFavorites) {
                                const favLocationsResult = risRepository.suggestFavorites(text, searchRole);
                                Promise.all([locationSearchResult, favLocationsResult]).then(([sr, fav]) => {
                                    const notFavoritedResults = sr.results.filter(x => fav.results.findIndex(ri => ri.isrs === x.isrs) === -1);
                                    const combinedResults = [...fav.results, ...notFavoritedResults.slice(0, 15 - fav.totalNumberOfResults)];
                                    const ret: RisIndexLocationSearchResult = { ...sr, results: combinedResults };
                                    kendoOptions.success(ret);
                                }).catch(e => {
                                    kendoOptions.error(e);
                                });
                            } else {
                                locationSearchResult.then(sr => kendoOptions.success(sr)).catch(e => kendoOptions.error(e));
                            }
                        } else {
                            if (searchFavorites) {
                                /* No filter.filters defined => use favorites if any */
                                const favLocationsResult = risRepository.suggestFavorites('', searchRole);
                                favLocationsResult.then(fav => kendoOptions.success(fav)).catch(e => kendoOptions.error(e));
                            } else {
                                kendoOptions.success(new RisIndexLocationSearchResult());
                            }
                        }
                    }
                } else {
                    if (searchFavorites) {
                        /* No filter defined => return favorites if any */
                        const favLocationsResult = risRepository.suggestFavorites('', searchRole);
                        favLocationsResult.then(fav => kendoOptions.success(fav)).catch(e => kendoOptions.error(e));
                    } else {
                        kendoOptions.success(new RisIndexLocationSearchResult());
                    }
                }
            }
        },
        serverPaging: true,
        serverFiltering: true,
        pageSize: 15,
        schema: {
            data: (data: RisIndexLocationSearchResult) => { return data.results; },
            total: (data: RisIndexLocationSearchResult) => { return data.totalNumberOfResults; }
        }
    };

    return new kendo.data.DataSource($.extend(dataSourceOptions, options));
}


